export default "__VITE_ASSET__C8XIO0uc__"